import ACTIONS from "../../constants/constants"

export const createCanvasApi = payload => ({
  type: ACTIONS.CREATE_CANVAS_API,
  payload,
})

export const clearCanvasApi = () => ({
  type: ACTIONS.CLEAR_CANVAS_API,
})
